import { Component, ReactNode } from "react";
import classNames from "classnames";
import styles from "./styles/RoundIcon.module.scss";
import { sourceTypesEnum } from "../../../utils/SourceUtils";

interface IRoundIconProps {
  className?: string;
  platform?: string;
  children?: ReactNode;
}

export default class RoundIcon extends Component<IRoundIconProps> {
  render() {
    const roundIconClassName = classNames({
      [styles.roundIcon]: true,
      [this.props.className ?? ""]: this.props.className,
      [styles.roundIconFacebook]:
        this.props.platform === sourceTypesEnum.FACEBOOK,
      [styles.roundIconTwitter]:
        this.props.platform === sourceTypesEnum.TWITTER,
      [styles.roundIconInstagram]:
        this.props.platform === sourceTypesEnum.INSTAGRAM,
      [styles.roundIconVimeo]: this.props.platform === sourceTypesEnum.VIMEO,
      [styles.roundIconYoutube]:
        this.props.platform === sourceTypesEnum.YOUTUBE,
      [styles.roundIconPinterest]:
        this.props.platform === sourceTypesEnum.PINTEREST,
      [styles.roundIconGoogle]:
        this.props.platform === sourceTypesEnum.GOOGLE_PLACES ||
        this.props.platform === sourceTypesEnum.GOOGLE_DRIVE,
      [styles.roundIconCalendar]: this.props.platform === sourceTypesEnum.ICAL,
      [styles.roundIconYelp]: this.props.platform === sourceTypesEnum.YELP,
      [styles.roundIconRss]: this.props.platform === sourceTypesEnum.RSS,
      [styles.roundIconError]: this.props.platform === sourceTypesEnum.ERROR,
      [styles.roundIconO365]: this.props.platform === sourceTypesEnum.O365,
      [styles.roundIconNewsFeed]:
        this.props.platform === sourceTypesEnum.SERP_API,
      [styles.roundIconParentsquare]:
        this.props.platform === sourceTypesEnum.PARENTSQUARE,
    });

    return <div className={roundIconClassName}>{this.props.children}</div>;
  }
}
